import React, { Component, createRef } from 'react';
import { FormInputProps } from '../../../shared/Types';

import './FormInput.scss';

type FormInputState = { inputChecked: boolean | undefined };

export default class FormInput extends Component<FormInputProps, FormInputState> {
  fieldClass: string;
  error: boolean;
  inputRef: React.RefObject<HTMLInputElement>;

  constructor(props: FormInputProps) {
    super(props);
    this.fieldClass = '';
    this.error = false;
    this.inputRef = createRef();
  }

  handleInputsValues = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.id === 'lastname' || event.target.id === 'firstname') {
      if (event.target.value.length < 2) {
        this.fieldClass = 'form__input invalid-input';
        this.error = true;
      } else {
        this.error = false;
        this.fieldClass = 'form__input';
      }
    }

    if (event.target.id === 'agreement' || event.target.id === 'date') {
      this.error = false;
    }
  };

  componentDidMount() {
    if (!this.inputRef.current?.defaultChecked) {
      this.error = true;
    }
  }

  render() {
    const { type, placeholder, id, className, min, max, defaultChecked, name } = this.props;
    return (
      <>
        <span className="field-title">{name}</span>
        <input
          data-testid="input"
          ref={this.inputRef}
          type={type}
          placeholder={placeholder}
          id={id}
          className={
            id === 'lastname' || id === 'firstname' ? this.fieldClass || className : className
          }
          min={min}
          max={max}
          name={name}
          onInput={this.handleInputsValues}
          defaultChecked={defaultChecked}
        />

        {id !== 'male' && id !== 'female' && (
          <span className="input-error" data-testid="error-message">
            {this.error ? 'invalid field' : ''}
          </span>
        )}
      </>
    );
  }
}
